/**
 * Calculates age in years from a birthdate
 * @param birthdate - Date object or ISO date string
 * @param defaultAge - default age of 13
 * @returns Age in years as a number
 */
export function calculateAge(
  birthdate: Date | string | undefined,
  defaultAge = 13
): number {
  const birth =
    (typeof birthdate === 'string' ? new Date(birthdate) : birthdate) ??
    new Date(new Date().getFullYear() - defaultAge, 0, 1)
  const today = new Date();

  let age = today.getFullYear() - birth.getFullYear();
  const monthDiff = today.getMonth() - birth.getMonth();

  // Adjust if birthday hasn't occurred this year yet
  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birth.getDate())) {
    age--;
  }

  return age;
}
